import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "@/lib/api";
import { toast } from "sonner";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { token, admin } = await adminLogin({ email, password });
      localStorage.setItem("melavi_admin_token", token);
      localStorage.setItem("melavi_admin_email", admin.email);
      toast.success(`Welcome, ${admin.email.split("@")[0]}`);
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ground px-6 py-24" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        className="w-full max-w-[420px] bg-white/60 hairline p-10"
        data-testid="admin-login-form"
      >
        <div className="nav-item mb-2" style={{ color: "var(--stone)" }}>MELAVI · Admin</div>
        <h1 className="serif text-4xl leading-tight mb-8">Come in.</h1>

        <label className="block nav-item mb-2" style={{ color: "var(--stone)" }}>Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-6 px-4 py-3 hairline bg-transparent focus:outline-none focus:border-ink"
          placeholder="admin@melavi.in"
          data-testid="admin-login-email"
        />

        <label className="block nav-item mb-2" style={{ color: "var(--stone)" }}>Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full mb-8 px-4 py-3 hairline bg-transparent focus:outline-none focus:border-ink"
          placeholder="••••••••"
          data-testid="admin-login-password"
        />

        <button
          type="submit"
          disabled={busy}
          className="btn-solid w-full"
          data-testid="admin-login-submit"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
